class AgeVerificationPopup extends ModalDialog {
  constructor() {
    super();
    if (Shopify.designMode) {
      window.addEventListener('shopify:section:load', this.init.bind(this));
    }
    this.init();
  }

  init() {
    this.ageVerified = getCookie("age-verified");

    this.noButton = this.querySelector(".button-no");
    this.yesButton = this.querySelector(".button-yes");

    // other popup elements
    this.newsletterPopup = document.getElementById(
      "NewsletterModal-newsletter-popup"
    );

    this.attachButtonListeners();

    setTimeout(() => {
      if (this.hasAttribute("open") && this.classList.contains('age-verification-popup--blurred')) {
        document.body.classList.add("age-verification-popup-is-open");
      }
    }, 5000);
  }

  connectedCallback() {
    // ModalDialog moves the modal to be a direct child of <body>.
    // AgeVerificationPopup overrides connectedCallback, so we must call super.
    super.connectedCallback();

    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    this.showPopupIfNecessary();
  }

  showPopupIfNecessary() {
    if (!this.ageVerified || this.ageVerified === "false") {
      if (this.newsletterPopup) {
        this.newsletterPopup.classList.add(
          "newsletter-popup-is-hidden"
        );
      }
      this.show();
    }
  }

  attachButtonListeners() {
    if (this.noButton) {
      this.noButton.addEventListener("click", () => {
        setCookie("age-verified", "false");
        this.handleNoButtonClick();
      });
    }

    if (this.yesButton) {
      this.yesButton.addEventListener("click", () => {
        this.setAgeVerifiedTrue();
        this.hide();
      });
    }
  }

  setAgeVerifiedTrue() {
    setCookie("age-verified", "true");
  }

  handleNoButtonClick() {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      window.location.href = this.noButton.href;
    }
  }

  show() {
    super.show();

    if (this.classList.contains('age-verification-popup--blurred')) {
      document.body.classList.add("age-verification-popup-is-open");
    }

    // Wait for open-state styles (visibility/opacity/transform) to apply before focusing.
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        const firstButton = this.querySelector(
          '.age-verification-popup__actions button, .age-verification-popup__actions a'
        );
        const focusTarget = this.dialogHolder || firstButton;
        if (this.dialogHolder) {
          this.dialogHolder.dataset.autoFocus = 'true';
        }

        if (focusTarget) focusTarget.focus({ preventScroll: true });

        const clearAutoFocus = () => {
          if (!this.dialogHolder) return;
          delete this.dialogHolder.dataset.autoFocus;
          this.dialogHolder.removeEventListener('keydown', clearAutoFocus);
          this.dialogHolder.removeEventListener('pointerdown', clearAutoFocus);
          this.dialogHolder.removeEventListener('mousedown', clearAutoFocus);
          this.dialogHolder.removeEventListener('touchstart', clearAutoFocus);
        };

        // Remove the "auto focus" state as soon as user interacts,
        // so :focus-visible styling can apply normally during keyboard navigation.
        if (this.dialogHolder) {
          this.dialogHolder.addEventListener('keydown', clearAutoFocus);
          this.dialogHolder.addEventListener('pointerdown', clearAutoFocus);
          this.dialogHolder.addEventListener('mousedown', clearAutoFocus);
          this.dialogHolder.addEventListener('touchstart', clearAutoFocus, { passive: true });
        }

        // If something else steals focus right after page load, pull it back once.
        setTimeout(() => {
          if (!this.hasAttribute('open')) return;
          if (this.contains(document.activeElement)) return;
          const retryTarget = this.dialogHolder || firstButton;
          if (retryTarget) retryTarget.focus({ preventScroll: true });
        }, 150);
      });
    });
  }

  hide() {
    super.hide();

    document.body.classList.remove("age-verification-popup-is-open");

    if (this.getAttribute("data-open-in-design-mode")) {
      this.removeAttribute("data-open-in-design-mode");
    }

    if (this.newsletterPopup) {
      this.newsletterPopup.classList.remove(
        "newsletter-popup-is-hidden"
      );
    }
  }
}

customElements.define("age-verification-popup", AgeVerificationPopup);
